var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseinfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    width: 1,
    height: 1,
    viewBox: "-1.3 -1.3 34.599 34.599"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "xMidYMid slice",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB5ElEQVRIib3XQYhNURzH8c+7MhgjYSGEbEgRkhRFIWUWhJK9EBs1GxuLWdopKyM7KSkpRRZWU2OjUaPISzGIlWYWPO/F5Fnce7nzmHfPvfO83+rf6fz+33Prf/7nfyvNZlOAlmE7NmAtlqAH3zGJd3iFUUzkJavkQFfjGHahN+BwNTzBXXwsCu3BEZxM4qJq4A7uYSoEOg+XsLUErFWjuJwcYkboIgxifQeAqapJzq/pQtSy4UKHgcTFN5BdyEKPYmeBZLUCe3ck+adBV+BEYIImbuIcbuFnoO94wvkN3Ye+QHN6LSYxLL6rIVqMPVnogUAjLMRB8an7xdUeqsPE1bsK1woYZ6uzEfaWMDbwEvUS3t0RNhc0TeEKLuKqf3ScHG2MsLKgqY43SVwtAV0eKddbUwU9US2aG+HLLKBlVIsw3mXohwhPuwwdizDSZehIhG940SVgFY20DT4WXolzMD+J+1ApAL3Pn947jE+Bxl6cxn6cEd57xyX1k50c1ok7zP/SAF4z/RF/iyHlLnyehlJgKxQeiKe4Tuo2HmYXZhpB+3HK7FrkD9xoBbaDEg/a57GpBPA5rosn/7+UN+FXsA2HsAUL2uytYwyP8Eyb2siDZrVUXOFrkjj9l5nAe/FXfQ5J9AtYOXpHMI4czwAAAABJRU5ErkJggg=="
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "icon_info",
    "data-name": "icon info",
    width: 32,
    height: 32,
    fill: "url(#pattern)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseinfo);
export default __webpack_public_path__ + "static/media/caseinfo.df528a4834682b434c22454f4636f0e8.svg";
export { ForwardRef as ReactComponent };